import { WiseAceLogo } from "@/components/WiseAceLogo";
import { ShieldCheck, FileText, TrendingUp } from "lucide-react";

export function AuthShell({ children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="hidden lg:flex flex-col justify-between p-12 relative overflow-hidden" style={{ background: "linear-gradient(155deg,#0B132B 0%,#1C2541 100%)" }}>
        <div className="absolute -right-20 -top-20 w-96 h-96 rounded-full" style={{ background: "radial-gradient(circle,#D4AF3722,transparent 70%)" }} />
        <div className="absolute -left-16 bottom-10 w-80 h-80 rounded-full" style={{ background: "radial-gradient(circle,#D4AF3715,transparent 70%)" }} />
        <WiseAceLogo light size={44} />
        <div className="relative z-10">
          <h1 className="font-display text-4xl font-extrabold text-white leading-tight">
            Precision invoicing,<br />quotes & payroll<br />
            <span className="text-[#D4AF37]">for growing businesses.</span>
          </h1>
          <p className="text-slate-300 mt-5 max-w-md text-sm leading-relaxed">
            WiseAce Projects and Solutions Pty Ltd — a complete platform to create invoices, manage quotes, run payslips and track every payment in one secure place.
          </p>
          <div className="flex flex-col gap-3 mt-8">
            {[
              [ShieldCheck, "Bank-grade session security"],
              [FileText, "Professional A4 documents & PDFs"],
              [TrendingUp, "Real-time revenue insights"],
            ].map(([Icon, t], i) => (
              <div key={i} className="flex items-center gap-3 text-slate-200 text-sm">
                <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center text-[#D4AF37]">
                  <Icon className="w-4 h-4" />
                </span>
                {t}
              </div>
            ))}
          </div>
        </div>
        <div className="relative z-10 text-xs text-slate-400">© {new Date().getFullYear()} WiseAce Projects and Solutions Pty Ltd</div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 md:p-10 bg-[#F8FAFC]">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 flex justify-center">
            <WiseAceLogo size={44} />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
